import Image from "next/image";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import styles from "./Slide.module.scss";

export type SlideProps = {
  label: string;
  image: StrapiEntity<StrapiImage>;
};

export const Slide = ({ label, image }: SlideProps) => {
  const strapiImage = formatStrapiEntity(image);

  return (
    <div className={styles.slide}>
      <div className={styles.imageContainer}>
        <Image
          src={addBasePathToStrapiMedia(strapiImage)}
          objectFit="fill"
          width="100%"
          height="100%"
          objectPosition="center"
          alt={strapiImage.alternativeText ?? ""}
          layout="fill"
        />
      </div>

      <div className={styles.label}>{label}</div>
    </div>
  );
};
